import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Global from '../../../store/global-selectors';

const sellerDefaultsSelector = createSelector(
  Global.selectSellerDefaultCurrency,
  Global.selectSellerHomeCountry,
  Global.selectSellerDefaultWeightUnit,
  (defaultCurrencyCode, defaultCountryCode, defaultWeightUnit) => ({
    defaultCurrencyCode,
    defaultCountryCode,
    defaultWeightUnit,
  }),
);

const useSellerDefaultsForCustoms = () => {
  return useSelector(sellerDefaultsSelector);
};

export default useSellerDefaultsForCustoms;
